// @generated by protobuf-ts 2.9.0
// @generated from protobuf file "services_common.proto" (package "aeolus.proto", syntax proto3)
// tslint:disable
//
//
// Copyright (c) 2022 Cambridge Design Partnership.
// All rights reserved.
//
//
//*
// Common types across the gRPC services, but which aren't relevant to the device
//
import type { BinaryWriteOptions } from "@protobuf-ts/runtime";
import type { IBinaryWriter } from "@protobuf-ts/runtime";
import { WireType } from "@protobuf-ts/runtime";
import type { BinaryReadOptions } from "@protobuf-ts/runtime";
import type { IBinaryReader } from "@protobuf-ts/runtime";
import { UnknownFieldHandler } from "@protobuf-ts/runtime";
import type { PartialMessage } from "@protobuf-ts/runtime";
import { reflectionMergePartial } from "@protobuf-ts/runtime";
import { MESSAGE_TYPE } from "@protobuf-ts/runtime";
import { MessageType } from "@protobuf-ts/runtime";
/**
 * *
 * Device metadata is extra information assigned to a device by a user, rather than being reported directly by the
 * device
 *
 * @generated from protobuf message aeolus.proto.DeviceMetadata
 */
export interface DeviceMetadata {
    /**
     * / A friendly name for the device, editable by users
     *
     * @generated from protobuf field: string name = 1;
     */
    name: string;
    /**
     * / The location of the device. Currently just free text editable by users, may be turned into lat/long later
     *
     * @generated from protobuf field: string location = 2;
     */
    location: string;
}
/**
 * *
 * Information about a SIM card
 *
 * @generated from protobuf message aeolus.proto.Sim
 */
export interface Sim {
    /**
     * @generated from protobuf field: string iccid = 1;
     */
    iccid: string;
    /**
     * @generated from protobuf field: aeolus.proto.SimStatus status = 2;
     */
    status: SimStatus;
    /**
     * @generated from protobuf field: aeolus.proto.RequestedSimStatus requested_status = 3;
     */
    requestedStatus: RequestedSimStatus;
}
/**
 * *
 * A requested next status of a SIM
 *
 * @generated from protobuf enum aeolus.proto.RequestedSimStatus
 */
export enum RequestedSimStatus {
    /**
     * @generated from protobuf enum value: RequestedSimStatus_NONE = 0;
     */
    RequestedSimStatus_NONE = 0,
    /**
     * @generated from protobuf enum value: RequestedSimStatus_ACTIVE = 1;
     */
    RequestedSimStatus_ACTIVE = 1,
    /**
     * @generated from protobuf enum value: RequestedSimStatus_INACTIVE = 2;
     */
    RequestedSimStatus_INACTIVE = 2
}
/**
 * *
 * The current status of a SIM
 *
 * @generated from protobuf enum aeolus.proto.SimStatus
 */
export enum SimStatus {
    /**
     * @generated from protobuf enum value: SimStatus_UNKNOWN = 0;
     */
    SimStatus_UNKNOWN = 0,
    /**
     * @generated from protobuf enum value: SimStatus_NEW = 1;
     */
    SimStatus_NEW = 1,
    /**
     * @generated from protobuf enum value: SimStatus_ACTIVE = 2;
     */
    SimStatus_ACTIVE = 2,
    /**
     * @generated from protobuf enum value: SimStatus_INACTIVE = 3;
     */
    SimStatus_INACTIVE = 3,
    /**
     * @generated from protobuf enum value: SimStatus_SCHEDULED = 4;
     */
    SimStatus_SCHEDULED = 4
}
// @generated message type with reflection information, may provide speed optimized methods
class DeviceMetadata$Type extends MessageType<DeviceMetadata> {
    constructor() {
        super("aeolus.proto.DeviceMetadata", [
            { no: 1, name: "name", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "location", kind: "scalar", T: 9 /*ScalarType.STRING*/ }
        ]);
    }
    create(value?: PartialMessage<DeviceMetadata>): DeviceMetadata {
        const message = { name: "", location: "" };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<DeviceMetadata>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: DeviceMetadata): DeviceMetadata {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string name */ 1:
                    message.name = reader.string();
                    break;
                case /* string location */ 2:
                    message.location = reader.string();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: DeviceMetadata, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string name = 1; */
        if (message.name !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.name);
        /* string location = 2; */
        if (message.location !== "")
            writer.tag(2, WireType.LengthDelimited).string(message.location);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message aeolus.proto.DeviceMetadata
 */
export const DeviceMetadata = new DeviceMetadata$Type();
// @generated message type with reflection information, may provide speed optimized methods
class Sim$Type extends MessageType<Sim> {
    constructor() {
        super("aeolus.proto.Sim", [
            { no: 1, name: "iccid", kind: "scalar", T: 9 /*ScalarType.STRING*/ },
            { no: 2, name: "status", kind: "enum", T: () => ["aeolus.proto.SimStatus", SimStatus] },
            { no: 3, name: "requested_status", kind: "enum", T: () => ["aeolus.proto.RequestedSimStatus", RequestedSimStatus] }
        ]);
    }
    create(value?: PartialMessage<Sim>): Sim {
        const message = { iccid: "", status: 0, requestedStatus: 0 };
        globalThis.Object.defineProperty(message, MESSAGE_TYPE, { enumerable: false, value: this });
        if (value !== undefined)
            reflectionMergePartial<Sim>(this, message, value);
        return message;
    }
    internalBinaryRead(reader: IBinaryReader, length: number, options: BinaryReadOptions, target?: Sim): Sim {
        let message = target ?? this.create(), end = reader.pos + length;
        while (reader.pos < end) {
            let [fieldNo, wireType] = reader.tag();
            switch (fieldNo) {
                case /* string iccid */ 1:
                    message.iccid = reader.string();
                    break;
                case /* aeolus.proto.SimStatus status */ 2:
                    message.status = reader.int32();
                    break;
                case /* aeolus.proto.RequestedSimStatus requested_status */ 3:
                    message.requestedStatus = reader.int32();
                    break;
                default:
                    let u = options.readUnknownField;
                    if (u === "throw")
                        throw new globalThis.Error(`Unknown field ${fieldNo} (wire type ${wireType}) for ${this.typeName}`);
                    let d = reader.skip(wireType);
                    if (u !== false)
                        (u === true ? UnknownFieldHandler.onRead : u)(this.typeName, message, fieldNo, wireType, d);
            }
        }
        return message;
    }
    internalBinaryWrite(message: Sim, writer: IBinaryWriter, options: BinaryWriteOptions): IBinaryWriter {
        /* string iccid = 1; */
        if (message.iccid !== "")
            writer.tag(1, WireType.LengthDelimited).string(message.iccid);
        /* aeolus.proto.SimStatus status = 2; */
        if (message.status !== 0)
            writer.tag(2, WireType.Varint).int32(message.status);
        /* aeolus.proto.RequestedSimStatus requested_status = 3; */
        if (message.requestedStatus !== 0)
            writer.tag(3, WireType.Varint).int32(message.requestedStatus);
        let u = options.writeUnknownFields;
        if (u !== false)
            (u == true ? UnknownFieldHandler.onWrite : u)(this.typeName, message, writer);
        return writer;
    }
}
/**
 * @generated MessageType for protobuf message aeolus.proto.Sim
 */
export const Sim = new Sim$Type();
